import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RegisteredAddress } from "../../../domain/entities/registered-address";
import { type FailedDeliveryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Loads the customer's registered addresses for the "Reagendar" picker. */
export const loadAddresses = createAsyncThunk<
  RegisteredAddress[],
  string,
  { dispatch: FailedDeliveryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOAD_ADDRESSES, async (requestId, { extra }) => {
  const { failedDeliveryRepo: repo } = extra;
  return repo.listAddresses({ requestId });
});
